var React = require('react');

function DeleteIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".inactive-icon-svg{fill:#AFAFAF;}")),React.createElement("path",{"className":"inactive-icon-svg","d":"M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,10,18Z","key":1}),React.createElement("rect",{"className":"inactive-icon-svg","x":"0","y":"9.01","z":"1","width":"20","height":"2","style":{},"key":2})]);
}

DeleteIcon.defaultProps = {"className":"campaign-status-icon rejected-icon","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 20 20","width":"20","height":"20"};

module.exports = DeleteIcon;

DeleteIcon.default = DeleteIcon;
